/**
 * ERC Wire Dangling Validator Adapter for DRC System
 *
 * This validator checks for wires that have an unconnected endpoint.
 *
 * Note: This validator requires schematic route data which is not currently
 * available in IDrcInputs. Returns empty results until route data is added.
 *
 * Feature-gated via DrcEnabledCheckers.ErcWireDanglingValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
/**
 * Validator that checks for dangling wires.
 */
export class ErcWireDanglingValidator {
    reviewType = ReviewType.DesignRuleCheckErcWireDangling;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(_inputs) {
        const foundProblems = [];
        // Note: This validator requires schematic route data which is not currently
        // available in IDrcInputs. Returns empty results until route data is added.
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcWireDanglingValidator.js.map